import React from "react";
import { Popover } from "antd";

const popover = ({ title, DetailsComponent }) => {
	return (
		<>
			<div className="popover-container-custom">
				<div className="form-group mb-0">
					<label className="mb-0 font-weight-bolder">{title}</label>
					<br />
				</div>
				{DetailsComponent}
			</div>
		</>
	);
};
const CustomPopover = ({ title, DetailsComponent, IconComponent }) => {
	return (
		<>
			<Popover
				placement="rightTop"
				className="cursor-pointer"
				content={popover({ title, DetailsComponent })}
				trigger="click"
			>
				{IconComponent}
			</Popover>
		</>
	);
};
export default CustomPopover;
